import { styled } from '@mui/material';
import { ReactComponent as Nok } from 'src/images/safetyView/dashboard/nok.svg';

export const ErrorIcon = styled(Nok)`
  width: 1rem;
  height: 1rem;
  color: ${(props) => props.theme.palette.error.main};
`;
